module.exports = __webpack_public_path__ + "static/elfhatbooties-31de249363200269233949fab33d70fc.jpeg";